export const profileSettingsUrl =
  'https://www.linkedin.com/public-profile/settings'
export const editProfileUrl =
  'https://www.linkedin.com/in/me/edit/forms/intro/new/'
export const profileActivityUrl =
  'https://www.linkedin.com/in/me/recent-activity/all/'
export const languageSettingsUrl =
  'https://www.linkedin.com/mypreferences/d/language/'
export const connectionsListUrl =
  'https://www.linkedin.com/mypreferences/d/settings/connections-visibility'
export const representCompanyUrl =
  'https://www.linkedin.com/mypreferences/d/settings/organization-and-interests'
export const emailVisibilityUrl =
  'https://www.linkedin.com/mypreferences/d/settings/email-address-visibility'
export const emailDiscoverabilityUrl =
  'https://www.linkedin.com/mypreferences/d/settings/discover-me-by-email-address'
export const phoneDiscoverabilityUrl =
  'https://www.linkedin.com/mypreferences/d/settings/discover-me-by-phone-number'
export const statusVisibilityUrl =
  'https://www.linkedin.com/mypreferences/d/settings/manage-my-active-status'
export const accountSignInSecurityUrl =
  'https://www.linkedin.com/mypreferences/d/categories/sign-in-and-security'
export const homeFeedUrl = 'https://www.linkedin.com/feed/'
export const dataUsageGenerativeAiUrl =
  'https://www.linkedin.com/mypreferences/d/settings/data-for-ai-improvement'
export const dataUsageSocialEconomicResearchUrl =
  'https://www.linkedin.com/mypreferences/d/settings/policy-and-academic-research'

// Notifications Urls
export const jobSearchNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/searching-for-a-job'
export const hiringNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/hiring-someone-job-posts'
export const connectingWithOthersNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/connecting-with-others'
export const postingCommentingNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/posting-and-commenting'
export const messagingNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/messaging'
export const groupsNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/groups'
export const pagesNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/pages'
export const eventsNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/attending-events'
export const newsNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/editors-choice'
export const reportsNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/reports-and-insights'
export const updatingYourProfileNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/updating-your-profile'
export const verificationsNotificationUrl =
  'https://www.linkedin.com/mypreferences/d/notification-categories/verifications-notifications'

export const voyagerApiMeUrl = 'https://www.linkedin.com/voyager/api/me'
